import { api } from "@/lib/api";

/**
 * Booking-related API calls grouped in one service module so pages stay thin.
 */
export async function createBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}

export async function createCheckoutSession(bookingId, originUrl) {
  const { data } = await api.post("/payments/checkout/session", {
    booking_id: bookingId,
    origin_url: originUrl,
  });
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/payments/checkout/status/${sessionId}`);
  return data;
}
